import * as z from "zod";

export const getUnifiedBillingEnabled = {
  name: "getUnifiedBillingEnabled" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ enabled: z.boolean() }),
};
